/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { CustomEditorTemplateProps, CustomSystemListFieldDefinition } from "@eisinc/CustomFieldDefinition";
import Close from "@eisinc/XDL/Icons/Close";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import Icon from "@insite/mobius/Icon";
import Typography from "@insite/mobius/Typography";
import * as React from "react";
import { css } from "styled-components";
import styled from "styled-components"

type Props = CustomEditorTemplateProps<FileModle[], CustomSystemListFieldDefinition>;

export interface FileModle {
    name: string;
    url: string;
    type: string;
    derivatives: { 'thumbnail': string, 'webImage': string };
}

type State = {
    selectedFiles: FileModle[];
};

const RemoveFileButton = styled.button`
    position: absolute;
    top: 0;
    right: 0;
    background: transparent;
    border: 0;
    cursor: pointer;
`;

export default class BynderSelectorField extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            selectedFiles: this.props.fieldValue || [],
        };
    }

    onSuccess = (assets: any, additionalInfo: any) => {
        const Scrim = document.querySelector('[class^=Scrim]');
        if (Scrim) {
            (Scrim as any).style.visibility = 'visible';
        }
        this.setState({ selectedFiles: assets });
        this.props.updateField(this.props.fieldDefinition.name, assets);
    }

    OpenBynderCompactView = () => {
        const Scrim = document.querySelector('[class^=Scrim]');
        if (Scrim) {
            (Scrim as any).style.visibility = 'hidden';
        }
        const targetIndex = Object.keys(window).indexOf("window") - 1;
        (window[targetIndex] as any).BynderCompactView?.open({
            onSuccess: this.onSuccess,
            portal: {
                url: 'dustin7.getbynder.com',
                editable: true
            },
            mode: "MultiSelect",
            assetTypes: ["IMAGE", "VIDEO"],
            // container: document.getElementById("bynder-compactview"),
        });
    }

    removeFile = (index: any) => {
        const newItems = [...this.state.selectedFiles];
        newItems.splice(index, 1);

        this.setState({ selectedFiles: newItems });
        this.props.updateField(this.props.fieldDefinition.name, newItems);
    }

    render() {
        const { selectedFiles } = this.state;
        return <>
            <Typography
                css={css`
                        margin: 25px 0 5px;
                        font-weight: bold;
                        display: block;
                    `}
                transform="uppercase"
            >
                {this.props.fieldDefinition.displayName}
            </Typography>
            <div id="bynder-compactview"></div>
            <StyledWrapper css={css` display: flex; flex-direction: column; `}>

                <Button onClick={this.OpenBynderCompactView}>Open Bynder Compact View</Button>

                <Typography>{translate("Selected Files")}:</Typography>
                {
                    selectedFiles.map((file, index) => {
                        return (
                            <StyledWrapper key={file.name} css={css` position: relative; padding-right: 20px; `}>
                                <Typography>{`${file.name} - ${file.type}`}</Typography>
                                <RemoveFileButton
                                    onClick={() => {
                                        this.removeFile(index);
                                    }}
                                >
                                    <Icon src={Close} color="danger" size={12} />
                                </RemoveFileButton>
                            </StyledWrapper>
                        );
                    })
                }
            </StyledWrapper>
        </>;
    }
}